<template>
    <div>Справочник статей расхода</div>
</template>

<script>
export default  {
    name: 'expense-article-view'
}
</script>